"use strict";
/**
 * @module Services.Control
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var control_group_serialiser_1 = require("./../../control/control-group-serialiser");
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
var control_registration_params_1 = require("./control-registration-params");
/**
 * Serialiser for {@link ControlRegistrationParams}
 */
var ControlRegistrationParamsSerialiserClass = /** @class */ (function (_super) {
    __extends(ControlRegistrationParamsSerialiserClass, _super);
    function ControlRegistrationParamsSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link AuthenticatorRegistrationRequest} from the stream
     *
     * @param bis  the input stream
     * @return     the {@link AuthenticatorRegistrationRequest} that was read
     */
    ControlRegistrationParamsSerialiserClass.prototype.read = function (bis) {
        var definitionId = Codec.readInt32(bis);
        var group = control_group_serialiser_1.ControlGroupSerialiser.read(bis);
        return new control_registration_params_1.ControlRegistrationParams({ id: definitionId }, group);
    };
    /**
     * Write a {@link ControlRegistrationParams} to the stream
     *
     * @param bos    the output stream
     * @param value  the {@link ControlRegistrationParams} to be written
     */
    ControlRegistrationParamsSerialiserClass.prototype.write = function (bos, value) {
        Codec.writeInt32(bos, value.definition.id);
        control_group_serialiser_1.ControlGroupSerialiser.write(bos, value.group);
    };
    return ControlRegistrationParamsSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.ControlRegistrationParamsSerialiserClass = ControlRegistrationParamsSerialiserClass;
/**
 * The {@link ControlRegistrationParamsSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.ControlRegistrationParamsSerialiser = new ControlRegistrationParamsSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/control/control-registration-params-serialiser.js
// module id = 1863
// module chunks = 1